var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6948_102100)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 49.405,
    rx: 40,
    ry: 39.9988,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7795 40.1758H15.1406C15.0318 40.1758 14.9275 40.219 14.8506 40.2959C14.7737 40.3728 14.7305 40.4772 14.7305 40.586V58.2249C14.7305 58.3337 14.7737 58.438 14.8506 58.5149C14.9275 58.5919 15.0318 58.635 15.1406 58.635H32.7795C32.8883 58.635 32.9927 58.5919 33.0696 58.5149C33.1465 58.438 33.1897 58.3337 33.1897 58.2249V40.586C33.1897 40.4772 33.1465 40.3728 33.0696 40.2959C32.9927 40.219 32.8883 40.1758 32.7795 40.1758ZM27.0366 52.0718C27.0366 52.1805 26.9934 52.2849 26.9165 52.3619C26.8396 52.4387 26.7352 52.482 26.6265 52.482H21.2937C21.185 52.482 21.0806 52.4387 21.0037 52.3619C20.9268 52.2849 20.8836 52.1805 20.8836 52.0718V46.739C20.8836 46.6303 20.9268 46.5259 21.0037 46.449C21.0806 46.3721 21.185 46.3289 21.2937 46.3289H26.6265C26.7352 46.3289 26.8396 46.3721 26.9165 46.449C26.9934 46.5259 27.0366 46.6303 27.0366 46.739V52.0718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7077 46.3301H64.3751C64.1485 46.3301 63.9648 46.5137 63.9648 46.7402V52.073C63.9648 52.2995 64.1485 52.4832 64.3751 52.4832H69.7077C69.9343 52.4832 70.118 52.2995 70.118 52.073V46.7402C70.118 46.5137 69.9343 46.3301 69.7077 46.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5534 40.1768H58.2208C57.9942 40.1768 57.8105 40.3604 57.8105 40.587V45.9196C57.8105 46.1462 57.9942 46.3299 58.2208 46.3299H63.5534C63.7801 46.3299 63.9637 46.1462 63.9637 45.9196V40.587C63.9637 40.3604 63.7801 40.1768 63.5534 40.1768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8582 40.1768H70.5255C70.2989 40.1768 70.1152 40.3604 70.1152 40.587V45.9196C70.1152 46.1462 70.2989 46.3299 70.5255 46.3299H75.8582C76.0847 46.3299 76.2683 46.1462 76.2683 45.9196V40.587C76.2683 40.3604 76.0847 40.1768 75.8582 40.1768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5534 52.4829H58.2208C57.9942 52.4829 57.8105 52.6665 57.8105 52.8931V58.2258C57.8105 58.4523 57.9942 58.636 58.2208 58.636H63.5534C63.7801 58.636 63.9637 58.4523 63.9637 58.2258V52.8931C63.9637 52.6665 63.7801 52.4829 63.5534 52.4829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8582 52.4829H70.5255C70.2989 52.4829 70.1152 52.6665 70.1152 52.8931V58.2258C70.1152 58.4523 70.2989 58.636 70.5255 58.636H75.8582C76.0847 58.636 76.2683 58.4523 76.2683 58.2258V52.8931C76.2683 52.6665 76.0847 52.4829 75.8582 52.4829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3151 40.1768H48.9825C48.756 40.1768 48.5723 40.3604 48.5723 40.587V45.9196C48.5723 46.1462 48.756 46.3299 48.9825 46.3299H54.3151C54.5417 46.3299 54.7254 46.1462 54.7254 45.9196V40.587C54.7254 40.3604 54.5417 40.1768 54.3151 40.1768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3151 52.4829H48.9825C48.756 52.4829 48.5723 52.6665 48.5723 52.8931V58.2258C48.5723 58.4523 48.756 58.636 48.9825 58.636H54.3151C54.5417 58.636 54.7254 58.4523 54.7254 58.2258V52.8931C54.7254 52.6665 54.5417 52.4829 54.3151 52.4829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5718 46.7344C48.5718 46.6256 48.5286 46.5213 48.4517 46.4444C48.3747 46.3675 48.2704 46.3243 48.1616 46.3243H42.4187V40.586C42.4187 40.4772 42.3755 40.3728 42.2986 40.2959C42.2216 40.219 42.1173 40.1758 42.0085 40.1758H36.6759C36.567 40.1758 36.4627 40.219 36.3858 40.2959C36.3088 40.3728 36.2656 40.4772 36.2656 40.586V58.2157C36.2656 58.3244 36.3088 58.4288 36.3858 58.5057C36.4627 58.5826 36.567 58.6258 36.6759 58.6258H42.0085C42.1173 58.6258 42.2216 58.5826 42.2986 58.5057C42.3755 58.4288 42.4187 58.3244 42.4187 58.2157V52.4774H48.1616C48.2704 52.4774 48.3747 52.4341 48.4517 52.3572C48.5286 52.2803 48.5718 52.1759 48.5718 52.0672V46.7344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6948_102100",
    x: 0.5,
    y: 0.40625,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6948_102100"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6948_102100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6948_102100",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkxIcon);
export default __webpack_public_path__ + "static/media/okx-icon.15ca7eadad7b4b5f19ea2bff0107e037.svg";
export { ForwardRef as ReactComponent };